export default {
  username: 'xxx'
}



// WEBPACK FOOTER //
// ./src/store/state/index.js